import { getCookie } from "../../utils/trainUtils";
import { railsConfig } from "../railsConfig";
import axios from 'axios';
import { generateId } from '../../utils/trainUtils';
import { MMT_AUTH } from "../../constants/TrainConstants";

export const getIrctcUserName = async () => {
  const traceId = generateId();
  let result = '';
  try {
    const mmtAuth = getCookie(MMT_AUTH);
    const url = railsConfig.getIrctcUserNameUrl;
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'mmt-auth': mmtAuth,
        "X-Trace-Id": traceId
      }
    });
    result = response?.data?.primary_irctc_id || '';
  } catch (error) {
    console.error("Error in fetching IRCTC Username: ", error);
  }
  return result;
};

export const updateIrctcUserName = async (verifiedUserId: string) => {
  const traceId = generateId();
  try {
    const mmtAuth = getCookie(MMT_AUTH);
    const url = railsConfig.updateIrctcUserName;
    const body = {
      primary_irctc_id: verifiedUserId,
    }
    await axios.post(url, body, {
      headers: {
        'Content-Type': 'application/json',
        'mmt-auth': mmtAuth,
        "X-Trace-Id": traceId
      }
    });
  } catch (error) {
    console.error("Error in updating IRCTC Username: ", error);
  }
};